import {ILogger, LogActionType} from '@telstra-connect/logger'

declare var global: {
  NREUM: {
    addPageAction(action: string, data: object)
    noticeError(error: Error)
  }
}

interface IHeader {
  key: string
  // tslint:disable-next-line: no-any
  value: any
}
interface IDataTrace {
  headers?: IHeader[]
  // tslint:disable-next-line: no-any
  [key: string]: any
}

export const isNewRelic = (): boolean => {
  return 'NREUM' in global
}

const newRelicError = 'New Relic Error'

export const NewRelicWebLogger: ILogger = {
  exceptionAsync(error: Error) {
    if (!isNewRelic()) {
      return
    }

    try {
      global.NREUM.noticeError(error)
    } catch (ex) {
      /*tslint:disable:no-console*/
      // eslint-disable-next-line no-console
      console.log(`${newRelicError} `, ex)
    }
  },

  logAsync(actionType: LogActionType, data: IDataTrace) {
    if (!isNewRelic()) {
      return
    }

    try {
      const filteredHeaders = data.headers.filter((header) => {
        const headersList = ['authorization', 'company-id', 'Cookie']
        return headersList.indexOf(header.key) === -1
      })
      global.NREUM.addPageAction(LogActionType[actionType], {
        ...data,
        ...(data.headers && {headers: filteredHeaders}),
      })
    } catch (ex) {
      /*tslint:disable:no-console*/
      // eslint-disable-next-line no-console
      console.log(`${newRelicError} `, ex)
    }
  },

  errorAsync(data: object) {
    if (!isNewRelic()) {
      return
    }
    NewRelicWebLogger.logAsync(LogActionType.ERROR, data)
  },

  errorTypedAsync(errorType: string, data?: object) {
    if (data) {
      NewRelicWebLogger.errorAsync({errorType, ...data})
    } else {
      NewRelicWebLogger.errorAsync({errorType})
    }
  },

  infoAsync(data: object) {
    if (!isNewRelic()) {
      return
    }

    NewRelicWebLogger.logAsync(LogActionType.INFO, data)
  },

  infoTypedAsync(infoType: string, data?: object) {
    if (data) {
      NewRelicWebLogger.infoAsync({infoType, ...data})
    } else {
      NewRelicWebLogger.infoAsync({infoType})
    }
  },
}
